/* eslint-disable @typescript-eslint/ban-ts-comment */
import { defineCustomElement } from "vue";
import ResourceDataDownload from "./index.ce.vue";

const CustomElement = defineCustomElement(ResourceDataDownload);

export function registerResourceDataDownload(tagName: string = "resource-data-download") {
  customElements.define(tagName, CustomElement);
  return CustomElement;
}
